import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/col/index.js
// module id = 375
// module chunks = 14